const BASE_PRICE = 10;

/**
 * Catering set-bazli fiyat hesaplama
 * 
 * Kural:
 * - 1 set = 4 ana kategoriden (corbalar, ana_yemekler, yardimci_yemekler, salatalar) 1er tane = €10
 * - 2 set = her kategoriden 2ser = €20, 3 set = 3er = €30, vs.
 * - sets = Math.min(kategori_sayilari) -> her kategoride en az o kadar urun varsa set olusur
 * - Herhangi bir kategori 0 ise -> set yok, tum urunler bireysel fiyatla
 * - Set olustuktan sonra kalan (ekstra) urunler bireysel fiyatla (price_addition)
 * - Mezeler her zaman bireysel fiyatla, set hesaplamasina dahil degil
 */
export function calculateCateringTotal(cateringMenu, itemQuantities) {
  if (!cateringMenu) return 0;

  const mainCats = [
    cateringMenu.corbalar || [],
    cateringMenu.ana_yemekler || [],
    cateringMenu.yardimci_yemekler || [],
    cateringMenu.salatalar || []
  ];

  const mezeler = cateringMenu.mezeler || [];

  const counts = mainCats.map(cat =>
    cat.reduce((sum, item) => sum + (itemQuantities[item.id] || 0), 0)
  );

  const mainTotal = counts.reduce((s, c) => s + c, 0);

  // Mezeler always priced individually
  let mezeTotal = 0;
  for (const item of mezeler) {
    mezeTotal += (itemQuantities[item.id] || 0) * (item.price_addition || 0);
  }

  if (mainTotal === 0) return mezeTotal;

  const sets = Math.min(...counts);

  // No complete sets
  if (sets === 0) {
    let sum = 0;
    for (const cat of mainCats) {
      for (const item of cat) {
        sum += (itemQuantities[item.id] || 0) * (item.price_addition || 0);
      }
    }
    return sum + mezeTotal;
  }

  // Set price
  const base = sets * BASE_PRICE;

  // Extra items beyond sets
  let extraPrice = 0;
  for (const cat of mainCats) {
    const allPrices = [];
    for (const item of cat) {
      const qty = itemQuantities[item.id] || 0;
      for (let i = 0; i < qty; i++) {
        allPrices.push(item.price_addition || 0);
      }
    }
    allPrices.sort((a, b) => a - b);
    for (let i = sets; i < allPrices.length; i++) {
      extraPrice += allPrices[i];
    }
  }

  return base + extraPrice + mezeTotal;
}

/**
 * Fiyat kirilimi bilgisi
 */
export function getCateringBreakdown(cateringMenu, itemQuantities) {
  const mainCats = [
    cateringMenu?.corbalar || [],
    cateringMenu?.ana_yemekler || [],
    cateringMenu?.yardimci_yemekler || [],
    cateringMenu?.salatalar || []
  ];
  const mezeler = cateringMenu?.mezeler || [];

  const counts = mainCats.map(cat =>
    cat.reduce((s, item) => s + (itemQuantities[item.id] || 0), 0)
  );

  const mezeCount = mezeler.reduce((s, item) => s + (itemQuantities[item.id] || 0), 0);

  const mainTotal = counts.reduce((s, c) => s + c, 0);
  const sets = Math.min(...counts);
  const extraItems = counts.reduce((s, c) => s + Math.max(0, c - sets), 0) + mezeCount;

  return { sets, extraItems, totalItems: mainTotal + mezeCount };
}

export { BASE_PRICE };
